import React from "react";
import AscComponent from "../../components/AscComponent";
import { Row, Col, Button, Glyphicon} from "react-bootstrap";
import InlineForm from "../Elements/FromGroup/InlineForm";
import DatePicker from "react-datepicker";
import Select, { Creatable } from "react-select";

import * as GlobalConst from "../../components/AscConstants";

export default class ControlLogMenu extends AscComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    getSearchBtn = () => {
        let {
            state,
            onSearch,
            langText,
        } = this.props;

        return (
            <Button
                className="ok-execute-btn button-size"
                bsStyle="info"
                onClick={e => onSearch(state.filtered)}
                disabled={state.loading || state.searchValidation}
            >
                {langText.Body.Search}
            </Button>
        )
    }

    getClearBtn = () => {
        let {
            onClear,
            langText
        } = this.props;

        return (
            <Button
                className="default-button button-size clear-button"
                onClick={e => onClear()}>
                {langText.Body.Clear}
            </Button>
        );
    }

    getHeaderConditionInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            getScopeGreaterEqual,
            onChange,
            userInfo,
        } = this.props;

        let itemArr = [];

        // エラーメッセージ
        if (state.message) {
            itemArr.push(
                <Col sm={12} md={12}>
                    <label className="search-message">{state.message}</label>
                </Col>
            );
        }

        // OEM以上は会社選択表示
        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push(
                <InlineForm
                    key="company_id"
                    controlId="company_id"
                    className="padding-bottom-05"
                    label={langText.Body.CompanyName}
                    type="select"
                    onChange={e => onChange(e, "cm12_id")}
                    options={state.companySelect}
                    value={getFilterData("cm12_id") ? getFilterData("cm12_id").value : ""}
                    placeholder={!state.companySelect[0] ?
                        <Glyphicon glyph="refresh" className="spinning"/> : langText.SelectOption.Placeholder
                    }
                />
            );
        }

        // 拠点名 - 会社管理者以上のみ表示
        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            itemArr.push(
                <InlineForm
                    key="DepartmentName"
                    controlId="DepartmentName"
                    className="padding-bottom-05"
                    label={langText.Body.DepartmentName}
                    type="select"
                    onChange={e => onChange(e, "cm13_id")}
                    options={state.departmentSelect || []}
                    value={getFilterData("cm13_id") ? getFilterData("cm13_id").value : ""}
                    placeholder={langText.SelectOption.Placeholder}
                    isClearable={true}
                />
            );
        }

        // フロア - 拠点管理者以上 + floor_flg
        const shouldShowFloor = getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system) 
            ? this.props.getSelectedCompanyFloorFlg() 
            : (userInfo && (userInfo.floor_flg === true || userInfo.floor_flg === "Y") && getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department));
        
        if (shouldShowFloor) {
            itemArr.push(
                <InlineForm
                    key="FloorName"
                    controlId="FloorName"
                    className="padding-bottom-05"
                    label={langText.Body.Floor}
                    type="select"
                    onChange={e => onChange(e, "floor_id")}
                    options={state.floorSelect || []}
                    value={getFilterData("floor_id") ? getFilterData("floor_id").value : ""}
                    placeholder={langText.SelectOption.Placeholder}
                    isClearable={true}
                />
            );
        }

        return itemArr;
    }

    getConditionInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            onChange,
            hourShowList,
            minuteShowList,
            menuNameSelect,
            executionDetailSelect
        } = this.props;

        let itemArr = [];

        // 実行ユーザー
        itemArr.push(
            <InlineForm
                key="ExecutionUser"
                controlId="ExecutionUser"
                className="padding-bottom-05"
                label={langText.Body.ExecUser}
            >
                <Creatable
                    onChange={e => onChange(e, "execution_user")}
                    options={state.executionUserSelect || []}
                    value={getFilterData("execution_user") || []}
                    placeholder={langText.Body.AllSelected}
                    isClearable={true}
                    isMulti={true}
                    formatCreateLabel={(inputValue) => `"${inputValue}"${langText.Message.Creating}`}
                    noOptionsMessage={() => langText.Message.Validation_string_input}
                />
            </InlineForm>
        );

        // 開始日
        itemArr.push(
            <InlineForm
                key="StartDatetime"
                controlId="StartDatetime"
                label={langText.Body.StartDate}
            >
                <Col className="padding-bottom-05">
                    <Col sm={12} md={6} lg={6} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "start_datetime")}
                            selected={getFilterData("start_datetime") ? getFilterData("start_datetime") : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={langText.Body.Today}
                            placeholderText={langText.Body.StartDate}
                            maxDate={getFilterData("end_datetime") ? getFilterData("end_datetime") : null}
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0">
                        <Select
                            key="start_ji"
                            value={getFilterData("start_ji")}
                            onChange={
                                e => onChange(e, "start_ji")
                            }
                            options={hourShowList}
                            isDisabled={(!state.filtered.some(row => row.id === "start_datetime"))}
                            placeholder="---"
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0 padding-bottom-05">
                        <Select
                            key="start_hun"
                            value={getFilterData("start_hun")}
                            onChange={
                                e => onChange(e, "start_hun")
                            }
                            options={minuteShowList}
                            isDisabled={(!state.filtered.some(row => row.id === "start_datetime"))}
                            placeholder="---"
                        />
                    </Col>
                </Col>
            </InlineForm>
        );

        // 終了日
        itemArr.push(
            <InlineForm
                key="EndDatetime"
                controlId="EndDatetime"
                label={langText.Body.EndDate}
            >
                <Col className="padding-bottom-05">
                    <Col sm={12} md={6} lg={6} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "end_datetime")}
                            selected={getFilterData("end_datetime") ? getFilterData("end_datetime") : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={langText.Body.Today}
                            placeholderText={langText.Body.EndDate}
                            minDate={getFilterData("start_datetime") ? getFilterData("start_datetime") : null}
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0">
                        <Select
                            key="end_ji"
                            value={getFilterData("end_ji")}
                            onChange={
                                e => onChange(e, "end_ji")
                            }
                            options={hourShowList}
                            isDisabled={(!state.filtered.some(row => row.id === "end_datetime"))}
                            placeholder="---"
                        />
                    </Col>
                    <Col sm={12} md={3} lg={3} className="padding-right-0 padding-bottom-05">
                        <Select
                            key="end_hun"
                            value={getFilterData("end_hun")}
                            onChange={
                                e => onChange(e, "end_hun")
                            }
                            options={minuteShowList}
                            isDisabled={(!state.filtered.some(row => row.id === "end_datetime"))}
                            placeholder="---"
                        />
                    </Col>
                </Col>
            </InlineForm>
        );

        // メニュー名 - 階層構造対応
        const formatMenuOptionLabel = (option, { context }) => {
            // 選択された値として表示される場合は階層表示なし
            if (context === 'value') {
                return option.label;
            }

            // ドロップダウンで表示される場合のみ階層表示
            const level = option.level;
            
            let marginLeft = "0px";
            let prefix = "";
            
            if (level > 0) {
                marginLeft = "15px";
                prefix = "└ ";
            }

            return (
                <div style={{ 
                    marginLeft: marginLeft,
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {level > 0 && (
                        <span style={{ 
                            marginRight: '5px', 
                            color: '#999',
                            fontSize: '12px'
                        }}>
                            {prefix}
                        </span>
                    )}
                    <span>{option.label}</span>
                </div>
            );
        };

        itemArr.push(
            <InlineForm
                key="MenuName"
                controlId="MenuName"
                className="padding-bottom-05"
                label={langText.Body.MenuName}
                type="select"
                onChange={e => onChange(e, "menu_name")}
                options={menuNameSelect || []}
                value={(getFilterData("menu_name") && getFilterData("menu_name").map(row => row.value)) || []}
                placeholder={langText.Body.AllSelected}
                isClearable={true}
                isMulti={true}
                formatOptionLabel={formatMenuOptionLabel}
            />
        );

        // 実行内容
        itemArr.push(
            <InlineForm
                key="ExecutionDetail"
                controlId="ExecutionDetail"
                className="padding-bottom-05"
                label={langText.Body.ExecutionDetail}
                type="select"
                onChange={e => onChange(e, "execution_detail")}
                options={executionDetailSelect || []}
                value={(getFilterData("execution_detail") && getFilterData("execution_detail").map(row => row.value)) || []}
                placeholder={langText.Body.AllSelected}
                isClearable={true}
                isMulti={true}
            />
        );

        return itemArr;
    }

    render() {
        return (
            <Row className="menu-row">
                <Col className="title-col col-style" xs={12} sm={12}>
                    <div className="margin-left-05 margin-top-05">
                        {this.getClearBtn()}
                        {this.getSearchBtn()}
                    </div>
                    <div>
                        {this.getHeaderConditionInfo()}
                        <hr className="menu-hr" />
                    </div>
                </Col>
                <Col className="col-style padding-top-0" xs={12} sm={12}>
                    {this.getConditionInfo()}
                </Col>
            </Row>
        );
    }
} 